// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--2wNKO";
export var content = "modal-module--content--m6Hve";
export var body = "modal-module--body--s7ngD";
export var cardHead = "modal-module--cardHead--2I3Iw";
export var cardFooter = "modal-module--cardFooter--1oOVl";